import React, { Component } from 'react'
import { connect } from 'react-redux'
import { map } from 'lodash'

import { Col, Row, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from '@fortawesome/free-solid-svg-icons'

import SelectBox from '../../../../shared/SelectBox'

import { AppState } from '../../../../../store'
import {
  SelectValue,
  CustomSelectValue,
  DistributeToManager,
  QueueTypeEnum,
} from '../../../../../shared/models'
import {
  btnDistributeText,
  btnLoadingText,
} from '../../../../../shared/constants'
import {
  taskCountOptionsForManagerAtTagging,
  taskCountOptionsForManagerAtFinding,
  taskCountOptionsForManagerAtFinal,
  getManagerUsers,
  formatUserDataForLabel,
  validateField,
  redistributeReserveToManagerDistributor,
  cancelActiveRequests,
  getCountriesToRedistributeFromManager,
  getCountriesBySicToRedistributeFromManager,
  getSicsToRedistributeFromManager,
  distributorGetBatchesFromSource,
} from '../../../../../services'
import { setSuccess } from '../../../../../store/actions'

interface CountriesSelectValue extends SelectValue {
  countrySicCount?: number
}
interface State {
  users: SelectValue[]
  sics: CustomSelectValue[]
  sic?: number | null
  countries: CountriesSelectValue[]
  domicileId?: number | null
  batches: CustomSelectValue[]
  selectedBatch: string | number
  taskCountOptions: SelectValue[]
  taskCountOptionSelected: number | string
  selectedSicsCount: number
  type: DistributeToManager
  destinationUserId?: number | null
  sourceUserId?: number | null
  isSubmitting: boolean
  btnDistributeText: string
}

interface DispatchProps {}

interface StateProps {
  type: DistributeToManager
}

type Props = StateProps & AppState & DispatchProps

const mapStateToProps = (state: AppState) => ({ ...state })
const mapDispatchToProps = () => ({})

const COMPANY_TYPE = 'Distributor'
class RedistributeQueueToManager extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const taskCountOptions = this.getTaskCountByProcess()
    this.state = {
      users: [],
      sics: [],
      sic: 0,
      countries: [],
      domicileId: 0,
      batches: [],
      selectedBatch: 0,
      taskCountOptions: taskCountOptions,
      taskCountOptionSelected: 0,
      destinationUserId: null,
      sourceUserId: null,
      type: props.type,
      isSubmitting: false,
      btnDistributeText,
      selectedSicsCount: 0,
    }
  }

  async componentDidMount(): Promise<void> {
    await cancelActiveRequests()
    await this.getInitialData()
  }

  setTaskCountsOptions(number): void {
    // add new value and set the new value
    const taskCountOptionsBase = this.getTaskCountByProcess()
    let NewtaskCountOptionsBase = taskCountOptionsBase.filter(
      element => element.value < number
    )
    NewtaskCountOptionsBase.push({
      value: number,
      label: number,
    })
    this.setState({
      taskCountOptions: NewtaskCountOptionsBase,
      taskCountOptionSelected: number,
    })
  }

  setMaxCompsByCountry(comps, fromStateCountries = false) {
    const sicCount = comps.reduce(
      (count, sic) => count + sic.countrySicCount,
      0
    )
    this.setTaskCountsOptions(sicCount)
    this.setState({ selectedSicsCount: sicCount })
    if (!fromStateCountries) {
      this.setState({
        countries: map(comps, comp => ({
          value: comp.id,
          label: comp.name,
          countrySicCount: comp.countrySicCount,
        })),
      })
    }
  }

  getTaskCountByProcess() {
    const isFindingReview =
      this.props.type ===
      DistributeToManager.FindingReviewToManagerFindingReview
    const isTaggingReview =
      this.props.type ===
      DistributeToManager.TaggingReviewToManagerTaggingReview
    return isFindingReview
      ? taskCountOptionsForManagerAtFinding()
      : isTaggingReview
      ? taskCountOptionsForManagerAtTagging()
      : taskCountOptionsForManagerAtFinal()
  }

  getCompanyStatus() {
    return this.props.type ===
      DistributeToManager.FindingReviewToManagerFindingReview
      ? QueueTypeEnum.FindingReview
      : this.props.type ===
        DistributeToManager.TaggingReviewToManagerTaggingReview
      ? QueueTypeEnum.TaggingReview
      : QueueTypeEnum.TaggingFinalReview
  }

  clearAll = () => {
    this.setState({
      domicileId: null,
      destinationUserId: null,
      selectedSicsCount: 0,
      sic: null,
      sourceUserId: null,
      taskCountOptionSelected: 0,
    })
  }

  async getUsers(): Promise<void> {
    const managerUsersResult = await getManagerUsers()
    const managerUsers = managerUsersResult ? managerUsersResult.data : []
    this.setState({
      users: map(managerUsers, user => {
        return {
          label: formatUserDataForLabel(user),
          value: user.userId,
        }
      }),
    })
  }

  async getCountries(
    sourceId: number,
    sic: number | null = null
  ): Promise<void> {
    const args = {
      sourceId,
      companyStatus: this.getCompanyStatus(),
      companyType: COMPANY_TYPE,
      sic,
    }
    const countriesToRedistribute = sic
      ? await getCountriesBySicToRedistributeFromManager(args)
      : await getCountriesToRedistributeFromManager(args)
    this.setMaxCompsByCountry(
      countriesToRedistribute ? countriesToRedistribute.data : []
    )
  }

  async getBatches(sourceUserId): Promise<void> {
    const args = {
      companyType: COMPANY_TYPE,
      userId: sourceUserId,
      companyStatus: this.getCompanyStatus(),
    }
    const batchesFromSource = await distributorGetBatchesFromSource(args)

    const batches = batchesFromSource ? batchesFromSource.data : []

    this.setState({
      batches: map(batches, item => {
        return {
          value: item.batchId,
          label: `${item.batchName} (${item.companiesCount})`,
          quantity: parseInt(item.companiesCount),
        }
      }),
    })
  }

  async getSics(sourceId: number): Promise<void> {
    const args = {
      sourceId,
      companyStatus: this.getCompanyStatus(),
      companyType: COMPANY_TYPE,
      sic: null,
    }

    const sicsToRedistribute = await getSicsToRedistributeFromManager(args)

    const sics = sicsToRedistribute ? sicsToRedistribute.data : []
    const sicCount = sics.reduce(
      (accumulator, sic) => accumulator + sic.sicCompanies,
      0
    )
    this.setTaskCountsOptions(sicCount)
    this.setState({
      sics: map(sics, sicNumber => ({
        value: sicNumber.sic,
        label: sicNumber.sic,
      })),
      selectedSicsCount: sicCount,
    })
  }

  async getInitialData(): Promise<void> {
    this.setState({
      destinationUserId: null,
      taskCountOptionSelected: 0,
      selectedBatch: 0,
      domicileId: 0,
      sic: 0,
      sourceUserId: null,
    })

    await this.getUsers()
  }

  async handleUserChange(userId: number, isSource: boolean): Promise<void> {
    let {
      sourceUserId: newSourceUserId,
      destinationUserId: newDestinationUserId,
    } = this.state

    if (isSource) {
      newSourceUserId = userId
    } else {
      newDestinationUserId = userId
    }

    if (newSourceUserId === newDestinationUserId) {
      if (isSource) {
        newDestinationUserId = null
      } else {
        newSourceUserId = null
      }
    }

    if (newSourceUserId === null || !userId.toString().length) {
      this.setState({
        domicileId: undefined,
        selectedSicsCount: 0,
        selectedBatch: 0,
        sic: undefined,
        sourceUserId: newSourceUserId,
        destinationUserId: newDestinationUserId,
        taskCountOptionSelected: 0,
      })
    } else if (isSource) {
      this.setState({
        sourceUserId: newSourceUserId,
        destinationUserId: newDestinationUserId,
        selectedBatch: 0,
      })
      await Promise.all([
        this.getSics(userId),
        this.getCountries(userId),
        this.getBatches(userId),
      ])
    } else {
      this.setState({
        sourceUserId: newSourceUserId,
        destinationUserId: newDestinationUserId,
      })
    }
  }

  async handleBatchChange(batchId: any): Promise<void> {
    if (Number(batchId) === 0) {
      this.setState({ selectedBatch: batchId })
      return this.setMaxCompsByCountry(this.state.countries, true)
    }

    const { batches } = this.state
    const batchFound = batches.find(batch => batch.value === batchId)
    let newTotalCompanies: number =
      batchFound && batchFound.quantity ? batchFound.quantity : 0

    this.setTaskCountsOptions(newTotalCompanies)
    this.setState({
      selectedBatch: batchId,
    })
  }

  async handleSicChange(sic: number): Promise<void> {
    const sourceUserId = Number(this.state.sourceUserId)
    await this.getCountries(sourceUserId, sic)
    this.setState({ sic, domicileId: 0 })
  }

  handleCountryChange(domicileId: number): void {
    if (Number(domicileId) === 0) {
      this.setState({ domicileId })
      return this.setMaxCompsByCountry(this.state.countries, true)
    }

    const { countries, selectedSicsCount } = this.state
    const selectedCountry = countries.find(
      country => country.value === +domicileId
    )
    let selectedSics = selectedSicsCount

    if (selectedCountry && selectedCountry.countrySicCount) {
      selectedSics = selectedCountry.countrySicCount
    }

    this.setTaskCountsOptions(selectedSics)
    this.setState({
      domicileId,
      selectedSicsCount: selectedSics,
    })
  }

  handleTaskCountChange(taskCountOptionSelected): void {
    this.setState({ taskCountOptionSelected })
  }

  disableButton(): void {
    this.setState({
      isSubmitting: true,
      btnDistributeText: btnLoadingText,
    })
  }

  async redistributeQueue(): Promise<void> {
    const {
      sourceUserId,
      destinationUserId,
      taskCountOptionSelected,
      type,
      sic,
      domicileId,
      selectedBatch,
    } = this.state
    if (
      validateField(destinationUserId, 'source') &&
      validateField(destinationUserId, 'destination')
    ) {
      this.disableButton()
      const result = await redistributeReserveToManagerDistributor({
        sourceUserId,
        destinationUserId,
        taskCount: taskCountOptionSelected,
        type,
        sic,
        domicileId,
        selectedBatch,
      })

      if (result) {
        setSuccess(
          `Successfully Redistributed ${result.data.distributedCount} Tasks`
        )
        await this.getInitialData()
        this.setState({
          isSubmitting: false,
          btnDistributeText,
        })
      }
    }
  }

  render(): JSX.Element {
    const {
      users,
      taskCountOptions,
      destinationUserId,
      sics,
      sic,
      countries,
      domicileId,
      batches,
      selectedBatch,
      sourceUserId,
      taskCountOptionSelected,
      isSubmitting,
      btnDistributeText,
    } = this.state

    const shouldDisableBatchesSelect = !!(
      (sic && Number(sic) !== 0) ||
      (domicileId && domicileId !== 0) ||
      !sourceUserId
    )

    return (
      <Col sm={12}>
        <SelectBox
          values={users}
          onSelect={({ value }) => this.handleUserChange(value, true)}
          formElementLabel="Source"
          initialLabel="Redistribute From"
          inline={true}
          selected={String(sourceUserId) || ''}
        />

        <SelectBox
          values={sics}
          onSelect={({ value }) => this.handleSicChange(value)}
          formElementLabel="SIC"
          initialLabel="Select SIC"
          inline={true}
          selected={sic || ''}
          disabled={!sourceUserId || selectedBatch !== 0}
        />

        <SelectBox
          values={countries}
          onSelect={({ value }) => this.handleCountryChange(value)}
          formElementLabel="Country Name"
          initialLabel="Select Country"
          inline={true}
          selected={String(domicileId) || ''}
          disabled={!sourceUserId || selectedBatch !== 0}
        />

        <SelectBox
          values={batches}
          onSelect={({ value }) =>
            this.handleBatchChange(value === '' ? 0 : value)
          }
          formElementLabel="Batch"
          initialLabel="Select Batch"
          inline={true}
          disabled={shouldDisableBatchesSelect}
          selected={String(selectedBatch) || ''}
        />

        <SelectBox
          values={users}
          onSelect={({ value }) => this.handleUserChange(value, false)}
          formElementLabel="Destination"
          initialLabel="Redistribute To"
          inline={true}
          selected={String(destinationUserId) || ''}
          disabled={!sourceUserId}
        />

        <SelectBox
          values={taskCountOptions}
          onSelect={({ value }) => this.handleTaskCountChange(value)}
          formElementLabel={`Number To Move (${taskCountOptionSelected})`}
          initialLabel={null}
          inline={true}
          selected={String(taskCountOptionSelected) || ''}
          disabled={!sourceUserId}
        />
        <p className="clear-all-selected" onClick={() => this.clearAll()}>
          Clear all
        </p>
        <Row className="justify-content-end">
          <Button
            className="btn btn-purple"
            onClick={() => this.redistributeQueue()}
            disabled={isSubmitting}
          >
            <FontAwesomeIcon icon={faSave} /> {btnDistributeText}
          </Button>
        </Row>
      </Col>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RedistributeQueueToManager)
